import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JTreeSelect from '@/components/jeecg/JTreeSelect';
import { querySysCategoryTreeList } from '@/api/api';
export default {
  name: "SysCategoryModal",
  components: {
    JTreeSelect: JTreeSelect
  },
  data: function data() {
    return {
      categoryTree: [],
      root: 0,
      form: this.$form.createForm(this),
      title: "操作",
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      validatorRules: {
        pid: {
          rules: [{
            required: true,
            message: '请选择父级节点!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入类型名称!'
          }]
        },
        code: {
          rules: [{
            required: true,
            message: '请输入类型编码!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择类型状态!'
          }]
        }
      },
      url: {
        add: "/sys/category/add",
        edit: "/sys/category/edit"
      },
      expandedRowKeys: [],
      pidField: "pid"
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.categoryTree = [];
      var ss = this.$route.path.split("/");
      this.root = ss[ss.length - 1];
      var param = {
        pid: this.root
      };
      querySysCategoryTreeList(param).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.categoryTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this2 = this;

      this.loadTree(), this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(_this2.model, 'pid', 'name', 'code', 'status', 'sort'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this3.model.id) {
            httpurl += _this3.url.add;
            method = 'post';
          } else {
            httpurl += _this3.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this3.model, values);
          console.log("表单提交数据", formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.submitSuccess(formData);
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    // popupCallback(row) {
    //     this.form.setFieldsValue(pick(row, 'pid', 'name', 'code'))
    // },
    submitSuccess: function submitSuccess(formData) {
      if (!formData.id) {
        var treeData = this.categoryTree;
        this.expandedRowKeys = [];
        this.getExpandKeysByPid(formData[this.pidField], treeData, treeData);
        this.$emit('ok', formData, this.expandedRowKeys.reverse());
      } else {
        this.$emit('ok', formData);
      }
    },
    getExpandKeysByPid: function getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].key == pid) {
            this.expandedRowKeys.push(arr[i].key);
            this.getExpandKeysByPid(arr[i]['parentId'], all, all);
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all);
          }
        }
      }
    }
  }
};